import {
  browserLocalPersistence,
  browserSessionPersistence,
  getAuth,
  inMemoryPersistence,
  initializeAuth,
  type Auth,
} from 'firebase/auth';

import { app } from './firebaseConfig';

// Initialize Auth once with storage implementations that avoid IndexedDB. Safari can leave
// IndexedDB-backed Firebase services pending indefinitely, especially with multiple tabs open.
// The ordered fallbacks keep the session usable when localStorage or sessionStorage is blocked.
const authDependencies: Parameters<typeof initializeAuth>[1] = {
  persistence: [
    browserLocalPersistence,
    browserSessionPersistence,
    inMemoryPersistence,
  ],
};

let auth: Auth;
try {
  // The runtime guard also lets component tests with older partial Firebase mocks reuse getAuth.
  auth = typeof initializeAuth === 'function'
    ? initializeAuth(app, authDependencies)
    : getAuth(app);
} catch (error) {
  // Preserve a usable session if explicit dependency initialization is unavailable. The auth-state
  // initialization timer and telemetry in App.tsx surface a persistent failure to users/operators.
  console.error('Firebase Auth explicit initialization failed; using registered defaults.', error);
  auth = getAuth(app);
}

export { auth };
